import { render, staticRenderFns } from "./AppoinmentForm.vue?vue&type=template&id=a5f95dcc&scoped=true&"
import script from "./AppoinmentForm.vue?vue&type=script&lang=js&"
export * from "./AppoinmentForm.vue?vue&type=script&lang=js&"
import style0 from "./AppoinmentForm.vue?vue&type=style&index=0&id=a5f95dcc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5f95dcc",
  null
  
)

export default component.exports